import {removeSession, setSessionToken, setSessionUser} from '../utils/sessionUtils';
import {initialState} from "../context/UserContext";

export const userReducer = (state, action) => {
    let user = {};
    if (action.type === 'SET_SESSION') {
        user = {
            ...state,
            userId: action.user.userId,
            username: action.user.username,
            languageCode: action.user.languageCode,
            userType: action.user.userType,
            firstName: action.user.firstName,
            lastName: action.user.lastName,
            cagId: action.user.cagId,
            fmapRole: action.user.fmapRole,
            personId: action.user.personId,
            agentId: action.user.agentId,
            locked: action.user.locked
        }
        setSessionToken(action.user.sessionToken);
        setSessionUser(user);
        return user;
    } else if (action.type === 'LOGIN_ERROR') {
        removeSession();
        return initialState;
    }

    return state;
}
